import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "../../../redux/axios/axios.js";
import '../commonCSS.css'
const validationSchema = Yup.object({
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState(null);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get("token");
    setToken(tokenFromUrl);
  }, [location]);

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!token) {
        alert("Invalid or expired token.");
        return;
      }
      try {
        const response = await axios.post(
          `http://192.168.0.156:8000/api/v1/users/reset-password?token=${token}`,
          {
            newPassword: values.password,
            confirmPassword: values.confirmPassword,
          }
        );
        if (response.data.success) {
          alert("Password reset successfully!");
          navigate("/");
        } else {
          alert("Error resetting password.");
        }
      } catch (error) {
        console.error("Error: ", error);
        alert("Something went wrong.");
      }
    },
  });

  if (!token) {
    return (
      <div className="container text-center mt-5">
        
        <h2 className="text-danger">Invalid or expired reset link.</h2>
      </div>
    );
  }

  return (
    <section className="vh-100 reset-background bg-gradient">
      <div className="container h-100 d-flex justify-content-center align-items-center">
        <div className="row w-100 justify-content-center">
          <div className="col-md-8 col-lg-6 col-xl-5">
            <div className="card shadow-lg border-0 rounded-4">
              <div className="card-body p-5">
                <h2 className="text-center mb-4 font-weight-bold text-primary">
                  Reset Your Password
                </h2>
                <p className="text-center mb-4 text-muted">
                  Please enter a new password to reset your account password.
                </p>
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-4">
                    <label htmlFor="password" className="form-label">
                      New Password
                    </label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      className="form-control"
                      placeholder="Enter New Password"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.password && formik.errors.password && (
                      <div className="text-danger mt-2">
                        {formik.errors.password}
                      </div>
                    )}
                  </div>
                  <div className="mb-4">
                    <label htmlFor="confirmPassword" className="form-label">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      className="form-control"
                      placeholder="Confirm New Password"
                      value={formik.values.confirmPassword}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.confirmPassword &&
                      formik.errors.confirmPassword && (
                        <div className="text-danger mt-2">
                          {formik.errors.confirmPassword}
                        </div>
                      )}
                  </div>

                  <div className="d-grid gap-2 mb-4">
                    <button type="submit" className="btn btn-primary btn-lg">
                      Reset Password
                    </button>
                  </div>
                </form>
                <div className="text-center">
                  <p>
                    Remember your password?{" "}
                    <Link
                      to="/login"
                      className="text-decoration-none text-primary"
                    >
                      Login here
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ResetPassword;
